import {useMutation} from "@tanstack/react-query";
import {updateDraftCustomerOfferMutationOptions} from "./update-draft-customer-offer.mutation-options";

export function useUpdateDraftCustomerOffer(id: string) {
  return useMutation(updateDraftCustomerOfferMutationOptions(id));
}
